import React, { useState, useRef, memo } from 'react';
import Tooltip from 'react-tooltip-lite';
import useEnlog from 'app/hook/common/useEnlog';

import Icon from 'app/components/common/Icon';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

import classNames from 'classnames/bind';
import styles from './TooltipPopper.module.scss';

const cx = classNames.bind(styles);

const TooltipPopper = (props) => {
	const ua = useSsrUserAgent();
	const {
		children = [],
		tagName = 'span',
		btnStyle = null,
		btnOnClick = undefined,
		icon = null,
		iconText = '자세히보기',

		direction = 'down',
		forceDirection = false,
		isOpen = null,
		eventToggle = null,

		theme = 'white',
		tooltip = null,
		contentClass = '',
		useDimmed = false,
		dimmedOnClick = undefined,
		fixedClass = '',

		wrapClass = '',
	} = props;

	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	const [view, setView] = useState(false);
	const buttonRef = useRef();

	const child = icon ? (
		<Icon
			className={cx(icon)}
			text={iconText}
		/>
	) : (
		children
	);

	let eventToggleDefault;
	if (eventToggle !== null) {
		eventToggleDefault = eventToggle;
	}
	if (eventToggle === null && ua().isPc) {
		eventToggleDefault = '';
	} else {
		eventToggleDefault = 'onClick';
	}

	const handleDimmedCick = () => {
		if (dimmedOnClick) {
			dimmedOnClick();
			return;
		}
		buttonRef.current.click();
	};

	return (
		<Tooltip
			tagName={tagName}
			className={cx('react-tooltip-lite-button')}
			direction={direction}
			forceDirection={forceDirection}
			isOpen={isOpen}
			eventToggle={eventToggleDefault}
			eventOff={useDimmed ? 'onClick' : ''}
			content={
				<>
					{useDimmed && (
						<div
							className={cx('dimmed')}
							role="presentation"
							onClick={handleDimmedCick}
						/>
					)}
					<div className={cx('area', wrapClass)}>{tooltip}</div>
				</>
			}
			tipContentClassName={cx('wrap', theme, contentClass, { view: view || isOpen }, { fixed: fixedClass }, fixedClass)}
			arrowContent={<span className="arrow" />}
			padding={0}
			mouseOutDelay={500}
			onToggle={(v) => setView(v)}
		>
			<button
				type="button"
				style={btnStyle}
				onClick={btnOnClick}
				className={view ? 'view' : ''}
				ref={buttonRef}
				{...dataSet}
			>
				{child}
			</button>
		</Tooltip>
	);
};

export default memo(TooltipPopper);
